import { configString } from 'utils/config';

const getSearchIndex = (sort?: string | null | undefined) => {
  if (sort === 'relevance') {
    return configString('algolia', 'siteIndexName');
  }

  return configString('algolia', 'sitePublishedDescIndexName');
};

// eslint-disable-next-line import/no-default-export
export default getSearchIndex;
